<template>
  <div
    :class="[
      $style.textInput,
      isFilled && $style.filled,
      error && $style.error,
      disabled && $style.disabled
    ]"
  >
    <textarea
      v-if="longText"
      :id="id"
      v-case="{
        upper: upperCase,
        lower: lowerCase
      }"
      :class="$style.input"
      :placeholder="placeholder"
      :disabled="disabled"
      :value="value"
      :maxlength="maxCharacters"
      rows="10"
      @input="$emit('update:value', $event.target.value)"
      @paste="onPaste"
    />

    <input
      v-else
      :id="id"
      v-case="{
        upper: upperCase,
        lower: lowerCase
      }"
      :class="$style.input"
      :type="type"
      :disabled="disabled"
      :placeholder="placeholder"
      :inputmode="inputmode"
      :autocomplete="autocomplete"
      :value="value"
      @input="$emit('update:value', $event.target.value)"
      @paste="onPaste"
    >

    <div
      v-if="maxCharacters !== null"
      :class="$style.charactersCount"
    >
      {{ charactersCount }}
    </div>

    <transition name="slide-fade">
      <Error
        v-if="error"
      >
        {{ error }}
      </Error>
    </transition>
  </div>
</template>

<style lang="scss" module>
.input {
  font-size: 1.4rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 16px;
  margin: 8px 0;
  transition: 0.3s border-color;
  letter-spacing: 0.7px;
  color: $color-text;
  border: solid 1px #cfcfcf;
  border-radius: 5px;
  outline: none;
  background-color: transparent;
  caret-color: #e992a3;
  resize: vertical;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;

    &:hover {
      border: solid 1px #cfcfcf;
    }
  }

  &:focus {
    border-color: #eea2b1;
  }

  &:hover {
    border-color: $grey-2;
  }

  .textInput.filled & {
    border-color: $grey-2;

    &:focus {
      border-color: #eea2b1;
    }
  }

  .textInput.error & {
    border-color: $red;
    caret-color: $red;

    &:focus {
      border-color: $red;
      caret-color: $red;
    }
  }

  &::placeholder {
    font-size: 1.4rem;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.6px;
    opacity: 0.23;
    color: $color-text;
  }
}

.charactersCount {
  font-size: 1.4rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  margin-top: 5px;
  letter-spacing: 0.5px;
  text-align: right;
  color: $color-text;
}
</style>

<script>
import Error from '../others/Error';

export default {
  components: {
    Error,
  },

  props: {
    id: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: null,
    },
    inputmode: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
      validator(value) {
        return [null, 'password', 'email', 'phone'].indexOf(value) !== -1;
      },
    },
    longText: {
      type: Boolean,
      default: false,
    },
    maxCharacters: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    preventPaste: {
      type: Boolean,
      default: false,
    },
    upperCase: {
      type: Boolean,
      default: false,
    },
    lowerCase: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isFilled() {
      return this.value && this.value.length > 0;
    },

    charactersCount() {
      return `${this.value ? this.value.length : 0}/${this.maxCharacters}`;
    },
  },

  methods: {
    onPaste(event) {
      this.preventPaste && event.preventDefault();
    },
  },
};
</script>
